import type { Composition } from '@/pages/calibration/composition'

export const compareVersions = (version1: string, version2: string): number => {
  const v1parts = version1.split('.').map(Number)
  const v2parts = version2.split('.').map(Number)
  const length = Math.max(v1parts.length, v2parts.length)
  for (let i = 0; i < length; i++) {
    const v1part = v1parts[i] ?? 0
    const v2part = v2parts[i] ?? 0
    if (v1part > v2part) return 1
    if (v1part < v2part) return -1
  }
  return 0
}

export const isVersionGreaterThanOrEqual = (
  version: string,
  targetVersion: string,
): boolean => compareVersions(version, targetVersion) >= 0

export const isNmdiWithFota = (composition: Composition | null): boolean => {
  if (!composition?.ncmType || !composition.composition?.['ncmFirmware']) {
    return false
  }

  const isNmdi = composition.ncmType === 'nmdi'
  const ncmFirmwareVersion = composition.composition['ncmFirmware']
  return isNmdi && isVersionGreaterThanOrEqual(ncmFirmwareVersion, '1.2.0')
}
